//api baseurl的管理
let doamin = 'http://192.168.10.31';

if (process.env.NODE_ENV === 'production') {
  doamin = ''
} else {
  doamin = 'http://192.168.10.31'
}

const base = {
  api: `${doamin}/vendor/api/`,
  storage: `${doamin}/vendor/storage/`
}
export default base;

